/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AutoTestUnitTestMessageSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('AUTO_TEST_UNIT_TEST_MESSAGE')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class AutoTestUnitTestMessageSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestUnitTestMessageSettingParser.decode(input).map(res => new AutoTestUnitTestMessageSetting(res));
    }
    static unsafeDecode(input) {
        return AutoTestUnitTestMessageSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestUnitTestMessageSettingParser.encode(data);
    }
    static schema() {
        return AutoTestUnitTestMessageSettingParser.schema();
    }
}
